var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-cases-en row-container"},[_c('ul',{staticClass:"items"},_vm._l((_vm.items),function(item){return _c('el-card',{key:item.index,attrs:{"shadow":"hover"}},[_c('li',[_c('img',{attrs:{"src":item.logo,"alt":""}})])])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }